import { Adapter } from '@fmnts/core';
import { QuizFieldset } from '../model/quiz-fieldset';
import { QuizFieldAdapter, QuizFieldToApiAdapter } from './quiz-field.adapter';

export class QuizFieldsetAdapter implements Adapter<QuizFieldset> {
  constructor(private fieldAdapter = new QuizFieldAdapter()) {}

  adapt(item: Record<string, any>): QuizFieldset {
    const fields = ((item['fields'] || []) as Record<string, any>[]).map(
      (field) => this.fieldAdapter.adapt(field),
    );

    return new QuizFieldset({
      key: item['key'],
      label: item['label'],
      fields,
      condition: item['condition'],
    });
  }
}

export class QuizFieldsetToApiAdapter {
  constructor(private fieldAdapter = new QuizFieldToApiAdapter()) {}
  adaptModelToDto(quizFieldset: QuizFieldset): { [key: string]: any } {
    return {
      key: quizFieldset.key,
      label: quizFieldset.label,
      fields: quizFieldset.fields.map((field) =>
        this.fieldAdapter.adaptModelToDto(field),
      ),
      condition: quizFieldset.condition,
    };
  }
}
